"use client";

import { ArrowRight, Check, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceArea() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const serviceAreas = ["Miami-Dade and surrounding areas", "Home or office service", "Travel availability may vary by location"];
  const pins = [{
    id: 1,
    top: "32%",
    left: "48%",
    label: "Valero HQ",
    address: "Miami, FL",
    isHQ: true
  }, {
    id: 2,
    top: "22%",
    left: "62%",
    label: "North Miami",
    address: "Mobile Service",
    isHQ: false
  }, {
    id: 3,
    top: "55%",
    left: "30%",
    label: "Coral Gables",
    address: "Mobile Service",
    isHQ: false
  }, {
    id: 4,
    top: "68%",
    left: "58%",
    label: "Kendall",
    address: "Mobile Service",
    isHQ: false
  }, {
    id: 5,
    top: "45%",
    left: "72%",
    label: "Key Biscayne",
    address: "Mobile Service",
    isHQ: false
  }, {
    id: 6,
    top: "38%",
    left: "22%",
    label: "Downtown",
    address: "Mobile Service",
    isHQ: false
  }];
  return <section data-section-id="892" id="miami-service-area-área-de-servicio-en-miami" ref={ref} className="w-full bg-background text-foreground">
      <div className="flex flex-col lg:flex-row w-full">
        {}
        
        {}
        <div className="w-full lg:w-2/5 bg-card flex items-center">
          <div className={`w-full px-8 py-16 sm:px-12 sm:py-20 lg:px-20 lg:py-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-8 bg-primary" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground">
                Service Area
              </span>
            </div>

            {}
            <h2 className="font-serif font-normal text-foreground leading-[1.05] tracking-tight text-[2rem] sm:text-[2.5rem] lg:text-[2.5rem]">
              We bring the <em>premium</em> detail to you.
            </h2>

            {}
            <p className="mt-6 text-base leading-relaxed text-muted-foreground font-sans max-w-md">
              Valero Elite Detailing provides mobile luxury car care across Miami-Dade and surrounding areas. We come to your home or office, ensuring your vehicle receives elite treatment.
            </p>

            {}
            <ul className="mt-10 space-y-4">
              {serviceAreas.map((area, i) => <li key={area} data-index={i} className="flex items-center gap-4 group">
                  <span className="flex items-center justify-center w-6 h-6 border border-border bg-background">
                    <Check className="w-3.5 h-3.5 text-primary" strokeWidth={2.5} />
                  </span>
                  <span className="font-sans text-foreground text-base sm:text-lg tracking-tight">
                    {area}
                  </span>
                  <span className="flex-1 h-px bg-border/60 ml-2" />
                </li>)}
            </ul>

            {}
            <div className="mt-12 pt-8 border-t border-border">
              <Link to="https://wa.me/17867784394" newTab className="inline-flex items-center gap-3 text-foreground hover:text-primary transition-colors duration-200 group">
                <span className="font-sans text-base font-medium tracking-tight">
                  Check your location availability.
                </span>
                <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}